import { render, staticRenderFns } from "./WuhanBaseInfo.vue?vue&type=template&id=18d8884c&scoped=true&"
import script from "./WuhanBaseInfo.vue?vue&type=script&lang=js&"
export * from "./WuhanBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./WuhanBaseInfo.vue?vue&type=style&index=0&id=18d8884c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8884c",
  null
  
)

export default component.exports